'use strict'
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault')
require('core-js/modules/es.array.filter')
require('core-js/modules/es.array.find')
require('core-js/modules/es.array.join')
require('core-js/modules/es.array.map')
require('core-js/modules/es.regexp.exec')
require('core-js/modules/es.string.split')
require('core-js/modules/es.string.trim')
exports.__esModule = true
exports.default = void 0
var _createClass2 = _interopRequireDefault(require('@babel/runtime/helpers/createClass'))
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'))

var _is = require('../is')
var _func = require('../func')

var _hour = _interopRequireDefault(require('./hour'))
var _time = _interopRequireDefault(require('./time'))
var _day = _interopRequireDefault(require('./day'))
var _date = _interopRequireDefault(require('./date'))
var _month = _interopRequireDefault(require('./month')) // "(19:00:00-19:01:00, 20:20:01-21:30:59); d0010100; D1,2,3,5-10,20; m0,1,2,5-8,11"

/**
 * TimingParser
 * @namespace TimingParser
 *
 * @class TimingParser
 */ var TimingParser = /*#__PURE__*/ (function() {
  function TimingParser(opts) {
    var _this = this
    if (opts === void 0) {
      opts = {}
    }
    ;(0, _defineProperty2.default)(this, 'hour', void 0)
    ;(0, _defineProperty2.default)(this, 'time', void 0)
    ;(0, _defineProperty2.default)(this, 'day', void 0)
    ;(0, _defineProperty2.default)(this, 'date', void 0)
    ;(0, _defineProperty2.default)(this, 'month', void 0)
    ;(0, _defineProperty2.default)(this, 'onValChange', void 0)
    ;(0, _defineProperty2.default)(this, 'onChange', void 0)
    ;(0, _defineProperty2.default)(this, 'onChangeDebounced', void 0)
    ;(0, _defineProperty2.default)(this, 'onChangeCb', void 0)
    ;(0, _defineProperty2.default)(
      this,
      'onValChange',

      function(name) {
        var ctrl = _this._getCtrl(name)

        if (ctrl === null) return
        var val = ctrl.val,
          str = ctrl.str

        _this.onChange({ name: name, val: val, str: str })
      }
    )
    ;(0, _defineProperty2.default)(
      this,
      'onChange',

      function(arg) {
        if ((0, _is.isF)(_this.onChangeCb)) {
          _this.onChangeCb(arg, _this)
        }
      }
    )
    this.onChangeCb = opts.onChange
    this.onChangeDebounced = (0, _func.debounce)(function() {
      _this.onChange.apply(_this, arguments)
    }, 100)
    var valProps = { onChange: this.onValChange }
    this.hour = new _hour.default(valProps)
    this.time = new _time.default(valProps)
    this.day = new _day.default(valProps)
    this.date = new _date.default(valProps)
    this.month = new _month.default(valProps)
    return this
  }
  var _proto = TimingParser.prototype
  _proto._getCtrl = function _getCtrl(name) {
    switch (name) {
      case 'time':
      case 'hour':
      case 'day':
      case 'date':
      case 'month': // $FlowFixMe
        return this[name]
      default:
        return null
    }
  }
  /**
   * Устанавливает значение определённого типа
   *
   * @param {NamesType} name
   * @param {ValType} val
   * @example
   * this.setVal( 'date', [ 2, 15, 31 ] )
   * @memberof TimingParser
   */
  _proto.setVal = function setVal(name, val) {
    var ctrl = this._getCtrl(name)
    if (ctrl === null) return
    ctrl.setFromVal(val)
  }
  /**
   * Возвращает все заданные значения в виде одной строки
   * @example
   * this.getStr()
   * // "(19:00:00-19:01:00, 20:20:01-21:30:59); d0010100; D1,2,3,5-10,20; m0,1,2,5-8,11"
   * @returns {string}
   *
   * @memberof TimingParser
   */ _proto.getStr = function getStr() {
    return this.controllers
      .map(function(ctrl) {
        return ctrl.str
      })
      .filter(function(maybeStr) {
        return maybeStr !== null
      })
      .join(';')
  }

  /**
   * Возвращает все заданные значения в виде массивов
   * @example
   * this.getVals()
   * // {
   * //   hour: [ 0, 300 ],
   * //   time: [ 0, 86399 ],
   * //   day: [ 1, 6 ],
   * //   date: [],
   * //   month: [ 11 ]
   * // }
   * @returns
   * @memberof TimingParser
   */
  _proto.getVals = function getVals() {
    return {
      hour: this.hour.val,
      time: this.time.val,
      day: this.day.val,
      date: this.date.val,
      month: this.month.val
    }
  }

  /**
   * Принимает строку таймингов и задаёт всё указанные значения
   *
   * @param {string} [str] "d0010100; D1,2,3,5-10,20"
   * @returns {TimingParser}
   * @memberof TimingParser
   */
  _proto.parseStr = function parseStr(str) {
    if (!(0, _is.isStr)(str)) return this
    var strings = str.split(';').map(function(s) {
      return s.trim()
    })
    var controllers = this.controllers
    var _loop = function _loop(ind) {
      var s = strings[ind]
      var strCtrl = controllers.find(function(ctrl) {
        return ctrl.validateStr(s) !== null
      })
      if (strCtrl !== undefined) {
        strCtrl.setFromStr(s)
      }
    }
    for (var ind = 0; ind < strings.length; ind++) {
      _loop(ind)
    }

    return this
  }

  /**
   * destroy
   *
   * @memberof TimingParser
   */
  _proto.destroy = function destroy() {
    this.onChangeCb = function() {}
    this.onValChange = function() {}
    this.onChangeDebounced = function() {}
  }
  ;(0, _createClass2.default)(TimingParser, [
    {
      key: 'controllers',
      get: function get() {
        return [this.hour, this.time, this.day, this.date, this.month]
      }
    }
  ])
  return TimingParser
})()
exports.default = TimingParser
;(0, _defineProperty2.default)(TimingParser, 'partNames', ['hour', 'time', 'day', 'date', 'month'])



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/TimingParser/index.js
// module id = 631
// module chunks = 0